export default function ({children}: {children:JSX.Element}) {
    return<div className={'mainContainer'}>
        <div className={'content'}>
            {children}
        </div>
    </div>
}